import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSearchParams } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { timeBR } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import { Tv } from "lucide-react";

export default function Kitchen() {
  const { restaurant } = useAuth();
  const [params] = useSearchParams();
  const tv = params.get("tv") === "1";
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    const load = async () => setOrders((await api.get("/orders")).data);
    load(); const t = setInterval(load, 5000); return () => clearInterval(t);
  }, []);

  if (tv) {
    const readies = orders.filter((o) => o.status === "pronto").slice(0, 12);
    return (
      <div className="min-h-screen bg-zinc-950 text-white p-8">
        <h1 className="font-display text-5xl font-extrabold text-center mb-8">Pedidos Prontos</h1>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {readies.map((o) => (
            <div key={o.id} className="rounded-2xl bg-emerald-500 text-zinc-950 p-8 shadow-xl animate-pulse-slow" data-testid={`tv-order-${o.number}`}>
              <div className="text-xs uppercase font-bold opacity-70">Pedido</div>
              <div className="font-display font-black text-7xl">#{o.number}</div>
              <div className="mt-3 font-display font-bold text-2xl truncate">{o.customer_name || "Balcão"}</div>
            </div>
          ))}
          {readies.length === 0 && <div className="col-span-full text-center text-zinc-500 text-xl py-20">Nenhum pedido pronto no momento.</div>}
        </div>
      </div>
    );
  }

  const active = orders.filter((o) => ["confirmado", "preparando", "pronto"].includes(o.status));
  const advance = async (o) => {
    const map = { confirmado: "preparando", preparando: "pronto", pronto: "saiu" };
    await api.patch(`/orders/${o.id}/status`, { status: map[o.status] || "pronto" });
    setOrders((await api.get("/orders")).data);
  };
  return (
    <div className="space-y-6" data-testid="kitchen-page">
      <div className="flex items-end justify-between">
        <h1 className="font-display text-3xl font-extrabold text-stone-900">Cozinha (KDS)</h1>
        <a href={`/tv/${restaurant?.slug}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm text-orange-600 font-semibold hover:underline" data-testid="tv-link"><Tv className="h-4 w-4" /> Abrir painel de senhas (TV) →</a>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {active.map((o) => (
          <div key={o.id} className="rounded-2xl bg-zinc-900 text-white p-5 border-2 border-zinc-800 hover:border-orange-500 transition" data-testid={`kds-${o.number}`}>
            <div className="flex items-center justify-between">
              <div className="font-display font-black text-3xl">#{o.number}</div>
              <Badge className="bg-orange-500 text-white capitalize">{o.status}</Badge>
            </div>
            <div className="text-xs text-zinc-400 mt-1">{o.channel} • {timeBR(o.created_at)}</div>
            <div className="mt-4 space-y-1 text-sm">
              {o.items.map((it, i) => (
                <div key={i} className="flex gap-2">
                  <span className="font-mono-num font-bold text-orange-400">{it.quantity}x</span>
                  <span>{it.name}</span>
                </div>
              ))}
            </div>
            <button onClick={() => advance(o)} className="mt-4 w-full rounded-lg bg-emerald-500 hover:bg-emerald-600 text-zinc-950 font-bold py-2" data-testid={`kds-advance-${o.number}`}>
              Avançar status
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
